// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 414) return "static/chunks/414-85badd6f36a99a66.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 0 ? "e99863e0" : chunkId) + "." + {"0":"454099c612bbe650","855":"be32e28d7bd47b10"}[chunkId] + ".js";
};